import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import GivingCountdown from "./GivingCountdown";
import MenuBarLink from "./MenuBarLink";

export class SubNavLeft extends PureComponent {
  render() {
    const { className, links, countdown, endCountdown, display_countdown } = this.props;

    const _className = className ? className : null;
    return (
      <div className={_className}>
        <GivingCountdown
          countdown={countdown}
          endCountdown={endCountdown}
          display_countdown={display_countdown}
        />
        <nav
          className={"giving-nav-links" + (!links.length ? " hidden" : "")}
          role="navigation"
          aria-label="Left Menu Bar Links">
          {links.map((link) => (
            <MenuBarLink key={link.id} link={link} />
          ))}
        </nav>
      </div>
    );
  }
}

SubNavLeft.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      external: PropTypes.bool,
    }),
  ).isRequired,
  countdown: PropTypes.bool,
  endCountdown: PropTypes.string,
  display_countdown: PropTypes.bool,
};

export default SubNavLeft;
